import { render, staticRenderFns } from "./FirmaKayit.vue?vue&type=template&id=eddc6f94&scoped=true&"
import script from "./FirmaKayit.vue?vue&type=script&lang=js&"
export * from "./FirmaKayit.vue?vue&type=script&lang=js&"
import style0 from "./FirmaKayit.vue?vue&type=style&index=0&id=eddc6f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc6f94",
  null
  
)

export default component.exports